<template>
  <div>
    <div style="padding:12px 16px;display: flex;align-items: center;margin-bottom: 10px;">
      <img src="../../../assets/images/icon_yunying.png" alt="" style="width: 20px;height: 20px;">
      <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.运营简报') }}</span>
    </div>
    <div v-loading="loading"
      style="background: #E8F0FF;border-radius: 2px;border: 1px solid #D9E4F8;padding:50px;display: flex;align-items: center;justify-content: space-between;">
      <IconDataItem :icon="require('@/assets/images/icon_total_vehicle.png')" :title="$t('龙翼简报.车辆总数')"
        :value="operationReport.TotalCount" extValue="" />
      <IconDataItem :icon="require('@/assets/images/icon_running.png')" :title="$t('龙翼简报.行驶')"
        :value="operationReport.DriveCount" :extValue="operationReport.DrivePercent + '%'" />
      <IconDataItem :icon="require('@/assets/images/icon_stop.png')" :title="$t('龙翼简报.停驶')"
        :value="operationReport.StopCount" :extValue="operationReport.StopPercent + '%'" />

      <IconDataItem :icon="require('@/assets/images/icon_offline.png')" :title="$t('龙翼简报.离线')"
        :value="operationReport.OffLineCount" :extValue="operationReport.OffLinePercent + '%'"
        color="#666666" />

      <IconDataItem v-if="activeTab == '5'" :icon="require('@/assets/images/icon_rechargin.png')"
        isRealData :title="$t('龙翼简报.充电')" :value="operationReport.ChargeCount"
        :extValue="operationReport.ChargePercent + '%'" color="#07B477" />

      <IconDataItem :icon="require('@/assets/images/icon_fault.png')" isRealData
        :title="$t('龙翼简报.故障')" :value="operationReport.FailureCount"
        :extValue="operationReport.FailurePercent + '%'" color="#FF106E" />

    </div>
  </div>
</template>
<script>
import IconDataItem from "./IconDataItem";
export default {
  name: "DashboardOperationReport",
  components: {
    IconDataItem
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    operationReport: {
      type: Object,
      default: () => ({
        TotalCount: 0,
        DriveCount: 0,
        DrivePercent: 0.0,
        StopCount: 0,
        StopPercent: 0.0,
        OffLineCount: 0,
        OffLinePercent: 0.0,
        ChargeCount: 0,
        ChargePercent: 0.0,
        FailureCount: 0,
        FailurePercent: 0.0
      })
    },
    activeTab: {
      type: String,
      default: "3"
    }
  }
};
</script>